import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useGetVideoQuery } from "../../../features/Admin/Videos/videosApi";
import Loading from "../../../components/Ui/Loading";
import Error from "../../../components/Ui/Error";
import moment from "moment";
import _ from "lodash";
import { clickedVideo } from "../../../features/Student/CoursePlayer/coursePlayerSlice";
import {
  useGetAssignmentMarkStudentQuery,
  useGetAssignmentWithVideoIdQuery,
} from "../../../features/Student/CoursePlayer/coursePlayerApi";
import Controls from "../../../components/controls/control";

export default function VideoPlayer({ videos, setModalIsOpen }) {
  // *****************************************************DECLARATION START******************************************************************************
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const { videoId } = useSelector((state) => state.coursePlayer);
  const {
    data: video,
    isLoading: videoIsLoading,
    isError: videoIsError,
    isSuccess: videoIsSuccess,
  } = useGetVideoQuery(videoId);
  const { id, title, description, url, createdAt } = video || {};

  const { data: assignments } = useGetAssignmentWithVideoIdQuery(videoId) || {};
  let assignmentStudent;

  console.log("assignments", assignments);
  const agnId = assignments?.length > 0 && assignments[0].id; // assuming you only need to use the first assignment ID
  assignmentStudent = useGetAssignmentMarkStudentQuery({
    sId: auth?.user?.id,
    agnId,
  });

  // *****************************************************DECLARATION END******************************************************************************
  // *****************************************************useEffect START******************************************************************************

  useEffect(() => {}, []);
  useEffect(() => {
    if (videoId === "") {
      dispatch(clickedVideo({ id: videos?.id, title: videos?.title }));
    }
  }, [dispatch, videos]);
  // *****************************************************useEffect END******************************************************************************
  // *****************************************************HANDLE START******************************************************************************
  // *****************************************************HANDLE END******************************************************************************
  // *****************************************************Decided which part render START******************************************************************************
  let videoContent = null;
  if (videoIsLoading) {
    videoContent = <Loading />;
  } else if (!videoIsLoading && videoIsError) {
    videoContent = (
      <Error
        header="Error !!"
        message="System error contact with administrator"
      />
    );
  } else if (!videoIsLoading && !videoIsError && _.isEmpty(video)) {
    videoContent = <Error header="" message="No video available" />;
  } else if (!videoIsLoading && !videoIsError && videoIsSuccess) {
    const inputDate = moment(createdAt);
    const outputDate = inputDate.format("DD MMMM YYYY");
    const showAssignmentBtn = assignments?.length > 0 ? true : false;
    videoContent = (
      <>
        <iframe
          width="100%"
          className="aspect-video"
          src={url}
          title={title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>

        <div>
          <h1 className="text-lg font-semibold tracking-tight text-slate-100">
            {title}
          </h1>
          <h2 className=" pb-4 text-sm leading-[1.7142857] text-slate-400">
            Uploaded on {outputDate}
          </h2>

          <div className="flex gap-4">
            {showAssignmentBtn && (
              <Controls.Button
                text="এসাইনমেন্ট"
                // disabled={assignmentStudent?.length !== 0 ? true : false}
                onClick={() => setModalIsOpen(true)}
                // className={`px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm ${
                //   assignmentStudent?.length === 0 &&
                //   "hover:bg-cyan hover:text-primary"
                // }`}
                className={`px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary
                `}
              />
            )}

            <Link
              to="/quiz"
              className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
            >
              কুইজে অংশগ্রহণ করুন
            </Link>
          </div>
          <p className="mt-4 text-sm text-slate-400 leading-6">{description}</p>
        </div>
      </>
    );
  }

  // *****************************************************Decided which part render END******************************************************************************

  return <>{videoContent}</>;
}
